import { t } from "../i18n";
import { media } from "../lib/api";
import ZellijeStar from "./ZellijeStar";

export const DeliveryProofCard = ({ locale = "en", photo, recipient, city, deliveredAt, shop, testid = "delivery-proof-card" }) => {
  const stamp = deliveredAt ? new Date(deliveredAt).toLocaleString(locale === "ar" ? "ar-MA" : locale, { dateStyle: "medium", timeStyle: "short" }) : "";
  return (
    <figure data-testid={testid} className="bg-plaster border border-brass-light max-w-[430px]">
      <div className="overflow-hidden">
        <img src={media(photo)} alt={t(locale, "deliveryProof")} className="w-full aspect-[4/5] object-cover block" />
      </div>
      <div className="border-t border-brass px-6 py-5 flex items-start justify-between gap-4">
        <div className="space-y-2">
          <div className="smallcaps text-brass">{t(locale, "deliveryProof")}</div>
          <dl className="space-y-1 text-sm">
            <div className="flex gap-2">
              <dt className="smallcaps w-[92px]">{t(locale, "recipient")}</dt>
              <dd data-testid="proof-recipient" className="text-charcoal">{recipient}</dd>
            </div>
            <div className="flex gap-2">
              <dt className="smallcaps w-[92px]">{t(locale, "city")}</dt>
              <dd data-testid="proof-city" className="text-charcoal">{city}</dd>
            </div>
            <div className="flex gap-2">
              <dt className="smallcaps w-[92px]">{t(locale, "deliveredAt")}</dt>
              <dd data-testid="proof-time" className="text-charcoal tabular">{stamp}</dd>
            </div>
            <div className="flex gap-2">
              <dt className="smallcaps w-[92px]">{t(locale, "arrangedBy")}</dt>
              <dd data-testid="proof-shop" className="text-charcoal">{shop}</dd>
            </div>
          </dl>
        </div>
        <ZellijeStar />
      </div>
    </figure>
  );
};

export default DeliveryProofCard;
